module.exports = __webpack_public_path__ + "img/Wp_2084.c3298b3d.png";